import { List, Datagrid, TextField, BooleanField, NumberField, ReferenceField, Pagination, SimpleShowLayout, Show, } from 'react-admin';

import TransactionFilter from './TransactionFilter';
import { DateTimeField } from '@/src/components';


const TransactionPagination = () => <Pagination rowsPerPageOptions={[25, 50, 100]} />;

export const TransactionList = () => (
    <List

        perPage={25}
        pagination={<TransactionPagination />}
        sort={{ field: 'updatedAt', order: 'DESC' }}
        filters={<TransactionFilter />}
        exporter={false}
    >
        <Datagrid rowClick="show"
            expand={<ExpandDetails />}
            bulkActionButtons={false}
        >
            <DateTimeField source="createdAt" />
            <DateTimeField source="updatedAt" />
            <ReferenceField label="User" source="user" reference="user">
                <TextField source="profile.nickname" />
            </ReferenceField>
            <ReferenceField label="Product" source="product" reference="product">
                <TextField source="title" />
            </ReferenceField>
            <ReferenceField label="Product Type" source="product" reference="product" link={false}>
                <TextField source="type" />
            </ReferenceField>
            <ReferenceField label="Recurrent" source="product" reference="product" link={false}>
                <TextField source="autoRenewal" />
            </ReferenceField>
            <NumberField source='dataList.length' label="Sub" />
            <NumberField source="amount" />
            <TextField source="currency" />
            <TextField source="status" />
            <TextField source="provider" />

        </Datagrid>
    </List>
);


const ExpandDetails = () => {
    return (
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="refId" />
            <TextField source="type" />
            <BooleanField source="isTest" />
        </SimpleShowLayout>
    )
}